import { Vue, Component, Model } from 'vue-property-decorator';
import { Button, Popup } from 'vant';
import style from './index.module.scss';

/** 身份证照片查询提示文案+弹窗。使用场景：身份认证页-“身份证不在身边？点击查询” */
@Component({ name: 'FindCardTips' })
export default class FindCardPopup extends Vue {
  @Model('change', {
    type: Boolean,
  })
  readonly visible!: boolean;

  private onConfirm() {
    this.$emit('confirm');
  }

  private onClose() {
    this.$emit('close');
  }

  private onClickTips() {
    this.$emit('clickTips');
  }

  private render() {
    return (
      <div class={style.findCardTips}>
        <span
          class={style.tips}
          onClick={() => this.onClickTips()}
        >
          身份证不在身边？点击查询
        </span>
        <span class={style.arrow} />
        <Popup
          position="bottom"
          class={style.popContent}
          v-model={this.visible}
          safeAreaInsetBottom={true}
          closeOnClickOverlay={false}
          onClick-overlay={this.onClose.bind(this)}
        >
          <div class={style.title}>
            身份证照片下载路径
            <span
              class={style.close}
              onClick={this.onClose.bind(this)}
            ></span>
          </div>
          <div class={style.descImg} />
          <Button
            type="primary"
            class={style.confirmButton}
            onClick={() => this.onConfirm()}
          >
            知道了
          </Button>
        </Popup>
      </div>
    );
  }
}
